module.exports = __webpack_public_path__ + "img/icon_football.7ee52e18.png";